import styled, { css } from 'styled-components';
import { Text } from '@lmn/design-system';

export const Price = styled(Text).attrs({ variant: 'Title3' })``;

export const TextPP = styled(Text).attrs({ variant: 'BodySmall' })``;

export const PriceWithTextContainer = styled.div<{ $marginBottom?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: flex-end;
  gap: 3px;
  ${({ $marginBottom }) =>
    $marginBottom &&
    css`
      margin-bottom: 8px;
    `}
`;
